import * as React from 'react';
import { InvertedLogo } from './InvertedLogo.js';
import { Anchor } from '../../components/Anchor/index.js';
export var PageFooter = function (_a) {
    var _b = _a.logo, logo = _b === void 0 ? React.createElement(InvertedLogo, null) : _b, _c = _a.home, home = _c === void 0 ? '/' : _c, left = _a.left, right = _a.right, copyrightHtml = _a.copyrightHtml;
    return (React.createElement("footer", null,
        React.createElement("div", { className: "container" },
            React.createElement("div", { className: "row footer-columns" },
                React.createElement("div", null,
                    React.createElement(Anchor, { url: home, className: "logo" }, logo)),
                React.createElement("div", null, left),
                React.createElement("div", null, right)),
            typeof copyrightHtml === 'string' ? (React.createElement("p", { className: "copy-rights h3", dangerouslySetInnerHTML: { __html: copyrightHtml } })) : (React.createElement("p", { className: "copy-rights h3" }, copyrightHtml)))));
};
//# sourceMappingURL=PageFooter.js.map